/* assets/get-a-quote-modal.js */
(function () {
  var HASH = "#getaquote";
  var OPENERS_SELECTOR = 'a[href="' + HASH + '"], button[data-href="' + HASH + '"]';
  var PRIMARY = "#0387D6FF";
  var formHost, formOriginalParent, formPlaceholder, modal, modalContent, closeBtn, lastFocused;
  var focusableSelectors = [
    'a[href]','area[href]','input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])','textarea:not([disabled])','button:not([disabled])',
    'iframe','audio[controls]','video[controls]','[contenteditable]','[tabindex]:not([tabindex="-1"])'
  ].join(",");

  function injectStyles() {
    if (document.getElementById("qb-getaquote-styles")) return;
    var css = [
      ".qb-gq-overlay{position:fixed;inset:0;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.6);z-index:9999;padding:20px;opacity:0;transition:opacity .18s ease}",
      ".qb-gq-overlay.is-open{display:flex;opacity:1}",
      ".qb-gq-dialog{position:relative;width:100%;max-width:880px;max-height:90vh;overflow:auto;border-radius:18px;background:#fff;box-shadow:0 16px 50px rgba(0,0,0,.28);transform:translateY(10px);transition:transform .18s ease}",
      ".qb-gq-overlay.is-open .qb-gq-dialog{transform:translateY(0)}",
      ".qb-gq-header{display:flex;align-items:center;justify-content:space-between;padding:16px 18px;border-bottom:1px solid rgba(0,0,0,.06)}",
      ".qb-gq-title{margin:0;font-size:20px;font-weight:800;color:#0b1220}",
      ".qb-gq-close{appearance:none;border:0;background:transparent;cursor:pointer;line-height:1;padding:8px;margin:-8px;font-size:22px;color:#111}",
      ".qb-gq-close:hover{opacity:.7}",
      ".qb-gq-body{padding:20px 18px}",
      ".qb-scroll-lock{overflow:hidden}",
      ".qb-gq-sr{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}",
      ".qb-gq-note{margin:0 0 14px 0;font-size:14px;color:#475163}",
      /* Form skin */
      ".qb-gq-body .sk-form,[sk-form-block]{--qb-primary:" + PRIMARY + ";}",
      ".qb-gq-body .sk-form *{box-sizing:border-box}",
      ".qb-gq-body .sk-form h1,.qb-gq-body .sk-form h2,.qb-gq-body .sk-form h3{color:#0b1220}",
      ".qb-gq-body .sk-form form{display:grid;gap:14px}",
      ".qb-gq-body .sk-form .sk-row{display:grid;grid-template-columns:1fr 1fr;gap:12px}",
      "@media(max-width:720px){.qb-gq-body .sk-form .sk-row{grid-template-columns:1fr}}",
      ".qb-gq-body .sk-form label{display:block;font-weight:700;font-size:14px;margin:2px 0 6px;color:#1b2538}",
      ".qb-gq-body .sk-form input[type=text],.qb-gq-body .sk-form input[type=email],.qb-gq-body .sk-form input[type=tel],.qb-gq-body .sk-form textarea{width:100%;border:1px solid #d8dee9;border-radius:10px;padding:12px 14px;font-size:16px;outline:none;background:#fff;color:#0b1220;transition:border-color .15s ease,box-shadow .15s ease}",
      ".qb-gq-body .sk-form textarea{min-height:120px;resize:vertical}",
      ".qb-gq-body .sk-form input:focus,.qb-gq-body .sk-form textarea:focus{border-color:var(--qb-primary);box-shadow:0 0 0 3px rgba(3,135,214,.15)}",
      ".qb-gq-body .sk-form .sk-checkboxes{display:grid;gap:8px}",
      ".qb-gq-body .sk-form .sk-checkbox{display:flex;align-items:center;gap:10px}",
      ".qb-gq-body .sk-form .sk-checkbox input[type=checkbox]{width:18px;height:18px;accent-color:var(--qb-primary)}",
      ".qb-gq-body .sk-form .sk-submit{margin-top:6px}",
      ".qb-gq-body .sk-form button[type=submit],.qb-gq-body .sk-form .sk-submit-btn{appearance:none;border:1px solid " + PRIMARY + ";background:" + PRIMARY + ";color:#fff;border-radius:12px;padding:12px 18px;font-weight:800;font-size:16px;cursor:pointer;transition:transform .05s ease,background-color .15s ease,color .15s ease}",
      ".qb-gq-body .sk-form button[type=submit]:hover,.qb-gq-body .sk-form .sk-submit-btn:hover{filter:brightness(.96)}",
      ".qb-gq-body .sk-form button[type=submit]:active,.qb-gq-body .sk-form .sk-submit-btn:active{transform:translateY(1px)}",
      ".qb-gq-body .sk-form .sk-help{font-size:12px;color:#6b7280}",
      ".qb-gq-body .sk-form .sk-success,.qb-gq-body .sk-form .sk-message{border:1px solid #d1fae5;background:#ecfdf5;color:#065f46;border-radius:12px;padding:14px 16px;font-size:15px}",
      /* Make embedded heading consistent with primary color */
      ".qb-gq-body .sk-form h1,.qb-gq-body .sk-form .sk-heading{color:" + PRIMARY + "}"
    ].join("");
    var style = document.createElement("style");
    style.id = "qb-getaquote-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function buildModal() {
    modal = document.createElement("div");
    modal.className = "qb-gq-overlay";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = [
      '<div class="qb-gq-dialog" role="document">',
      '  <div class="qb-gq-header">',
      '    <h2 class="qb-gq-title">Get a quote</h2>',
      '    <button type="button" class="qb-gq-close" aria-label="Close">×</button>',
      '  </div>',
      '  <div class="qb-gq-body"></div>',
      '</div>',
      '<span class="qb-gq-sr" tabindex="0"></span>'
    ].join("");
    document.body.appendChild(modal);
    modalContent = modal.querySelector(".qb-gq-body");
    closeBtn = modal.querySelector(".qb-gq-close");
    modal.addEventListener("click", function (e) { if (e.target === modal) closeModal(); });
    closeBtn.addEventListener("click", closeModal);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) closeModal();
      if (e.key === "Tab" && isOpen()) trapFocus(e);
    });
  }

  function isOpen() { return modal && modal.classList.contains("is-open"); }

  function getFocusable() {
    return Array.prototype.slice.call(modal.querySelectorAll(focusableSelectors))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function trapFocus(e) {
    var f = getFocusable();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openModal() {
    if (!formHost) return;
    lastFocused = document.activeElement;
    if (!formPlaceholder) {
      formPlaceholder = document.createComment("sk-form-placeholder");
      formOriginalParent.insertBefore(formPlaceholder, formHost);
    }
    modalContent.appendChild(formHost);
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("qb-scroll-lock");
    document.body.classList.add("qb-scroll-lock");
    setTimeout(function () {
      var first = getFocusable()[0] || closeBtn;
      if (first) first.focus();
    }, 0);
  }

  function closeModal() {
    if (!formHost) return;
    if (formPlaceholder && formPlaceholder.parentNode) {
      formPlaceholder.parentNode.insertBefore(formHost, formPlaceholder);
    }
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("qb-scroll-lock");
    document.body.classList.remove("qb-scroll-lock");
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function handleOpenerClick(e) {
    var href = this.getAttribute("href") || this.getAttribute("data-href");
    if (href === HASH) {
      e.preventDefault();
      if (!isOpen()) openModal();
      try { history.pushState(null, "", HASH); } catch(e){}
    }
  }

  function bindOpeners() {
    var openers = document.querySelectorAll(OPENERS_SELECTOR);
    openers.forEach(function (el) { el.addEventListener("click", handleOpenerClick); });
  }

  function onHashChange() {
    if (location.hash === HASH) { if (!isOpen()) openModal(); }
    else { if (isOpen()) closeModal(); }
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    injectStyles();
    buildModal();
    bindOpeners();

    formHost = document.querySelector("footer sk-form");
    if (!formHost) formHost = document.querySelector("sk-form");
    if (!formHost) return;
    formOriginalParent = formHost.parentNode;

    window.addEventListener("hashchange", onHashChange);
    if (location.hash === HASH) openModal();
  });
})();



/* get-a-quote-others-toggle.js */
(function () {
  function qs(root, sel) {
    try { return root.querySelector(sel) || null; } catch { return null; }
  }

  function waitForNodes(root, map, timeoutMs = 8000) {
    return new Promise((resolve) => {
      const start = Date.now();
      const getState = () => {
        const state = {};
        for (const key in map) state[key] = qs(root, map[key]);
        return state;
      };
      const done = (state) => Object.values(state).every(Boolean);

      let state = getState();
      if (done(state)) return resolve(state);

      const observer = new MutationObserver(() => {
        state = getState();
        if (done(state) || Date.now() - start > timeoutMs) {
          observer.disconnect();
          resolve(state);
        }
      });

      observer.observe(root, { childList: true, subtree: true });

      setTimeout(() => {
        observer.disconnect();
        resolve(getState());
      }, timeoutMs + 100);
    });
  }

  function initForContainer(container) {
    const selectors = {
      servicesBlock: '#sk-input-Services',
      othersCheckbox: '#sk-input-Services input.quote-services[value^="others"]',
      specifyWrap: '#sk-input-Please_Specify',
      specifyTextarea: '#sk-input-Please_Specify textarea'
    };

    waitForNodes(container, selectors, 8000).then((nodes) => {
      const { servicesBlock, othersCheckbox, specifyWrap, specifyTextarea } = nodes;
      if (!servicesBlock || !othersCheckbox || !specifyWrap || !specifyTextarea) return;

      specifyWrap.style.display = "none";
      specifyTextarea.required = false;

      const update = () => {
        const checked = othersCheckbox.checked;
        specifyWrap.style.display = checked ? "" : "none";
        specifyTextarea.required = checked;
      };

      update();

      servicesBlock.addEventListener("change", (e) => {
        if (e.target && e.target.matches('input.quote-services')) update();
      });
    });
  }

  function boot() {
    const forms = document.querySelectorAll('.sk-form[sk-form-block]');
    forms.forEach((form) => initForContainer(form));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();
